<template>
  <li class="nav-item dropdown">
    <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown"
      >{{ user.last }}, {{ user.first }}</a
    >
    <div class="dropdown-menu">
      <router-link
        to="/admin/vendors"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Vendors</router-link
      >
      <router-link
        to="/admin/occupations"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Occupations</router-link
      >
      <router-link
        to="/admin/services"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Services</router-link
      >
      <div class="dropdown-divider"></div>
      <router-link
        to="/admin/users"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Users</router-link
      >
      <router-link
        to="/admin/user-reports"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Reported Users</router-link
      >
      <div class="dropdown-divider"></div>
      <router-link
        to="/admin/notifications-settings"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Notifications Settings</router-link
      >
      <div class="dropdown-divider"></div>
      <router-link
        :to="{ name: 'logout' }"
        class="dropdown-item"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        >Logout</router-link
      >
    </div>
  </li>
</template>
<script>
export default {
  name: "AdminNav",
  props: ["user"],
};
</script>
